<template>
    <card>
        <card-header>
            <card-overline>Produzentenreklamation</card-overline>
        </card-header>
        <card-content>
            <table class="table table--card table--stripped">
                <thead>
                <tr>
                    <th>Eingangsdatum</th>
                    <th>Menge</th>
                    <th>Grund</th>
                    <th>Kommentar</th>
                    <th>berechtigt</th>
                    <th>Status</th>
                    <th>Wiedervorlage</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="producerComplaint in producerComplaintTable" :key="producerComplaint.index">
                    <td>{{ producerComplaint.complaint_at_string }}</td>
                    <td>{{ producerComplaint.amount }}</td>
                    <td>{{ producerComplaint.complaint_reason_string }}</td>
                    <td>{{ producerComplaint.comment }}</td>
                    <td>{{ producerComplaint.reason_valid_string }}</td>
                    <td>{{ producerComplaint.closed_string }}</td>
                    <td>{10.10.2022}</td>
                    <td class="small">
                        <form-button icon="document-edit" dense="true"
                                     @click="producerComplaintModal = !producerComplaintModal, editProducerComplaint = producerComplaint"/>

                        <form-button type="button" dense="true"
                                     @click="deleteDialog = true; deleteRoute = this.$$route('ask-for-quote.order-information.producer-complaint.delete', {'askForQuote': this.askForQuote, 'producerComplaint': producerComplaint.id})"
                                     icon="trash-delete-bin-2" />

                    </td>
                </tr>
                </tbody>
            </table>

            <modal-dialog title="Produzentenreklamation löschen" text="Möchten Sie die Produzentenreklamation wirklich löschen?"
                          confirm="löschen" v-if="deleteDialog" @closeDialog="deleteDialog = false;"
                          @confirmDialog="deleteMethod"/>

        </card-content>
        <card-content>
            <form-button class="btn--block" color="secondary" @click="producerComplaintModal = true;" icon="menu-edit-pen-add-circle" :disabled="disabledTab || ! hasProducerIncomingGoods">neue P-Reklamation</form-button>
            <producer-complaint-modal :ask-for-quote="askForQuote" :producer-complaint="editProducerComplaint" :forward-client-complaint="forwardClientComplaint"
                                      v-if="producerComplaintModal"
                                      @closeDialog="producerComplaintModal = false; forwardClientComplaint = false; editProducerComplaint = null; this.$emit('closeDialog')" :admin-users="adminUsers"/>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ProducerComplaintModal from '@partfactory/Pages/Admin/AskForQuote/Modals/ProducerComplaintModal';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';
export default {
    name: 'ProducerComplaint',
    components: {ModalDialog, ProducerComplaintModal, FormButton, CardContent, CardOverline, CardHeader, Card},
    props: {
        askForQuote: Object,
        adminUsers: Object,
        forwardClientComplaintProp: Boolean,
        producerComplaintModalProp: Boolean,
        editProducerComplaintProp: Object,
    },
    data() {
        return {
            forwardClientComplaint: this.forwardClientComplaintProp,
            producerComplaintModal: this.producerComplaintModalProp,
            editProducerComplaint: this.editProducerComplaintProp,
            deleteDialog: false,
            deleteRoute: null,
        };
    },
    computed: {
        producerComplaintTable() {
            let producerComplaints = this.askForQuote?.producer_complaints;
            producerComplaints?.forEach(producerComplaint => {
                producerComplaint.complaint_at_string = this.$date(producerComplaint.complaint_at);
                producerComplaint.complaint_reason_string = this.$readableComplaintReason(producerComplaint.complaint_reason_id);
                producerComplaint.creator_string = producerComplaint.creator === 1 ? 'Partfactory' : 'Kunde';
                producerComplaint.reason_valid_string = producerComplaint.reason_valid === -1 ? 'Offen' : producerComplaint.reason_valid === 1 ? 'Ja' : 'Nein';
                producerComplaint.closed_string = producerComplaint.closed === true ? 'geschlossen' : 'offen';

                return producerComplaint;
            });
            return producerComplaints;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 99);
        },
        hasProducerIncomingGoods() {
            return this.askForQuote.incoming_goods_producer.length > 0;
        },
    },
    methods: {
        deleteMethod() {
            this.$inertia.delete(this.deleteRoute);
            this.deleteRoute = null;
            this.deleteDialog = false;
        },
    },
    watch: {
        forwardClientComplaintProp: function(value){
            this.forwardClientComplaint = value;
        },
        producerComplaintModalProp: function(value){
            this.producerComplaintModal = value;
        },
        editProducerComplaintProp: function(value){
            this.editProducerComplaint = value;
        },
    },
    emits: ['closeDialog'],
};
</script>
